import React from "react";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { Button, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select } from "@material-ui/core";
import { connect } from "react-redux";
import Assolement from "../indicateurs/Assolement";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import network from "../../../../../actions/external/network";
import NumberInput from "../../../../common/NumberInput";

const mapStateToProps = (state) => ({
  userRole: state.auth.role,
});

const indicToWatch = [
  "HVE4_CULT_D_1",
  "HVE4_CULT_D_2",
  "HVE4_CULT_D_3",
  "HVE4_CULT_D_4",
  "HVE4_CULT_D_5",
  "HVE4_CULT_D_6",
  "HVE4_CULT_D_7",
  "HVE4_CULT_D_8",
  "HVE4_CULT_D_9",
  "HVE4_CULT_D_10",
  "HVE4_CULT_D_11",
  "HVE4_CULT_D_12",
  "HVE4_CULT_D_13",
  "HVE4_CULT_D_14",
  "HVE4_CULT_D_15",
  "HVE4_CULT_D_16",
  "HVE4_CULT_D_17",
  "HVE4_CULT_D_18",
  "HVE4_CULT_D_19",
  "HVE4_CULT_D_20",
  "HVE4_CULT_D_20_1",
  "HVE4_CULT_D_20_2",
  "HVE4_CULT_D_21",
  "HVE4_CULT_D_22",
  "HVE4_CULT_D_23",
  "HVE4_CULT_D_24",
  "HVE4_CULT_D_25",
  "HVE4_CULT_D_26",
  "HVE4_CULT_D_27",
  "HVE4_CULT_D_28",
  "HVE4_CULT_D_29",
  "HVE4_CULT_D_30",
  "HVE4_CULT_D_31",
  "HVE4_CULT_D_32",
  "HVE4_CULT_D_33",
  "HVE4_CULT_D_34",
  "HVE4_CULT_D_35",
  "HVE4_CULT_D_36",
  "HVE4_CULT_D_37",
  "HVE4_CULT_D_38",
  "HVE4_CULT_D_39",
  "HVE4_CULT_D_40",
  "HVE4_CULT_D_41",
  "HVE4_CULT_D_42",
  "HVE4_CULT_D_43",
  "HVE4_CULT_D_44",
  "HVE4_CULT_D_45",
  "HVE4_CULT_D_46",
  "HVE4_CULT_D_47",
];

class SurfaceSAU extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openListEspece: false,
      selectedValue: "",
      cultures: [],
    };
  }
  handleOpen = (event) => {
    this.setState({ openListEspece: true });
  };
  handleClose = (event) => {
    this.setState({ openListEspece: false });
    setTimeout(() => {
      document.activeElement.blur();
    }, 0);
  };

  handleSelectEspece = (event) => {
    this.setState({ selectedValue: "" });
    this.addLine(event);
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({ loading: true });
    const [cultures] = await Promise.all([network.fetch("/api/cultures")]);

    this.setState({
      cultures: cultures.filter((c) => c.idTypeCultureDefaut === 34),
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    let check = indicToWatch.some((indic) => this.props.indicateurs[indic] !== nextProps.indicateurs[indic]);
    let showSelectEspece = this.state.showSelectEspece !== nextState.showSelectEspece;
    let culturesVerger = this.state.cultures !== nextState.cultures;
    let especesVerger = this.props.assolement !== nextProps.assolement;
    let openListEspece = this.state.openListEspece !== nextState.openListEspece;
    return check || showSelectEspece || culturesVerger || especesVerger || openListEspece;
  }
  handleChangeIndicateur = (newIndicateur) => {
    const { changeIndicateur, sousRubriqueIndex, libelleEnglobantIndex } = this.props;
    changeIndicateur(newIndicateur, sousRubriqueIndex, libelleEnglobantIndex);
  };

  addLine = (newAssolement) => {
    const { addAssolement } = this.props;
    addAssolement(newAssolement);
  };

  render() {
    const { indicateurs, computedFields, assolement, getValueAssolement, changeAssolement } = this.props;
    const { openListEspece, selectedValue, cultures } = this.state;
    const idCulturesUsed = assolement.filter((a) => a.codeTypeCulture === "VERGER").map((a) => a.idCulture);
    const categories = [
      {
        label: "Céréales",
        keys: [
          "HVE4_CULT_D_1",
          "HVE4_CULT_D_2",
          "HVE4_CULT_D_3",
          "HVE4_CULT_D_4",
          "HVE4_CULT_D_5",
          "HVE4_CULT_D_6",
          "HVE4_CULT_D_7",
          "HVE4_CULT_D_8",
        ],
      },
      {
        label: "Oléagineux",
        keys: ["HVE4_CULT_D_9", "HVE4_CULT_D_10", "HVE4_CULT_D_11", "HVE4_CULT_D_12", "HVE4_CULT_D_13"],
      },
      {
        label: "Protéagineux",
        keys: ["HVE4_CULT_D_14", "HVE4_CULT_D_15", "HVE4_CULT_D_16", "HVE4_CULT_D_17", "HVE4_CULT_D_18"],
      },
      {
        label: "Fibres et surfaces gelées",
        keys: ["HVE4_CULT_D_19", "HVE4_CULT_D_20", "HVE4_CULT_D_20_1", "HVE4_CULT_D_20_2", "HVE4_CULT_D_21"],
      },
      { label: "Fourrages", keys: ["HVE4_CULT_D_22", "HVE4_CULT_D_23", "HVE4_CULT_D_24", "HVE4_CULT_D_25"] },
      {
        label: "Surfaces en herbe",
        keys: [
          "HVE4_CULT_D_26",
          "HVE4_CULT_D_27",
          "HVE4_CULT_D_28",
          "HVE4_CULT_D_29",
          "HVE4_CULT_D_30",
          "HVE4_CULT_D_31",
          "HVE4_CULT_D_32",
          "HVE4_CULT_D_33",
          "HVE4_CULT_D_34",
        ],
      },
      { label: "Cultures industrielles", keys: ["HVE4_CULT_D_35", "HVE4_CULT_D_36", "HVE4_CULT_D_37"] },
      {
        label: "Légumes, fleurs et fruits hors arboriculture",
        keys: [
          "HVE4_CULT_D_38",
          "HVE4_CULT_D_39",
          "HVE4_CULT_D_40",
          "HVE4_CULT_D_41",
          "HVE4_CULT_D_42",
          "HVE4_CULT_D_43",
          "HVE4_CULT_D_44",
          "HVE4_CULT_D_45",
        ],
      },
    ];

    const filterIndicators = (keys) =>
      Object.values(Object.fromEntries(Object.entries(indicateurs).filter(([key]) => keys.includes(key))));

    const arboVitiKeys = ["HVE4_CULT_D_44", "HVE4_CULT_D_45"];
    const arboVitiKeysEnd = ["HVE4_CULT_D_46", "HVE4_CULT_D_47"];

    const arboVitiToDisplay = filterIndicators(arboVitiKeys);
    const arboVitiEndToDisplay = filterIndicators(arboVitiKeysEnd);
    return (
      <React.Fragment>
        {categories.map(({ label, keys }) => {
          const indicatorsToDisplay = filterIndicators(keys);
          return indicatorsToDisplay.length > 0 ? (
            <div key={label}>
              <h2 className="my-1">{label}</h2>
              <div className={"d-flex mb-1"}>
                <Grid item xs={4} />
                <Grid item xs={8} className={"d-flex"}>
                  <div style={{ width: "4rem" }} />
                  <div style={{ width: "10rem", fontWeight: "bold" }}>N</div>
                  <div style={{ width: "10rem", fontWeight: "bold" }}>N</div>
                  <div style={{ width: "10rem", fontWeight: "bold" }}>N-1</div>
                  <div style={{ width: "10rem", fontWeight: "bold" }}>N-2</div>
                </Grid>
              </div>
              <div>
                {indicatorsToDisplay.map((indic) => (
                  <div className="d-flex align-items-center mb-1" key={"indic-" + indic.idIndicateur}>
                    <Grid item xs={4}>
                      <div className={indic.afficherGras ? "mr-3 bold" : "mr-3"}>{indic.libelle}</div>
                    </Grid>
                    <Grid item>
                      <Assolement
                        fixedDecimalScale={true}
                        size="small"
                        getValueAssolement={getValueAssolement}
                        indicateur={indic}
                        changeIndicateur={this.handleChangeIndicateur}
                        valueInputProps={
                          indic.libelleUnite !== null && {
                            endAdornment: <InputAdornment position="end">{indic.libelleUnite}</InputAdornment>,
                          }
                        }
                        computedFields={computedFields}
                        showValueN_1N_2={true}
                        disabled={indic.codeNational === "HVE4_CULT_D_45"}
                      />
                    </Grid>
                  </div>
                ))}
              </div>
            </div>
          ) : null;
        })}
        {arboVitiToDisplay.length > 0 && (
          <div className="my-2">
            {assolement
              .filter((a) => a.codeTypeCulture === "VERGER")
              .map((a, i) => (
                <div className="d-flex align-items-center mb-1" key={"assolement-" + i}>
                  <Grid item xs={4}>
                    <div className="mr-3 ml-2" style={{ borderBottom: "1px solid rgba(224, 224, 224, 1)" }}>
                      {a.regroupementCulture}
                    </div>
                  </Grid>
                  <Grid item xs={8} className={"d-flex"}>
                    <NumberInput
                      label={"Valeur assolement"}
                      size={"small"}
                      fullWidth={false}
                      style={{ width: "8rem" }}
                      value={a.surface}
                      onChange={(event) => changeAssolement(event, i, a, "surface")}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{"Ha"}</InputAdornment>,
                      }}
                      fixedDecimalScale={true}
                    />
                    <NumberInput
                      size={"small"}
                      fullWidth={false}
                      style={{ width: "8rem", marginLeft: "12rem" }}
                      onChange={(event) => changeAssolement(event, i, a, "surfaceN_1")}
                      value={a.surfaceN_1}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{"Ha"}</InputAdornment>,
                      }}
                      fixedDecimalScale={true}
                    />
                    <NumberInput
                      size={"small"}
                      fullWidth={false}
                      style={{ width: "8rem", marginLeft: "2rem" }}
                      onChange={(event) => changeAssolement(event, i, a, "surfaceN_2")}
                      value={a.surfaceN_2}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{"Ha"}</InputAdornment>,
                      }}
                      fixedDecimalScale={true}
                    />
                  </Grid>
                </div>
              ))}

            <Button color="primary" onClick={this.handleOpen}>
              <FontAwesomeIcon icon={"plus"} />
            </Button>
            {
              <FormControl size="small">
                <InputLabel id="demo-select-small-label">Ajouter une espèce</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-controlled-open-select"
                  label={"Ajouter une espèce"}
                  variant="outlined"
                  value={selectedValue}
                  onChange={this.handleSelectEspece}
                  onClose={this.handleClose}
                  onOpen={this.handleOpen}
                  open={openListEspece}
                  style={{ minWidth: "15rem" }}
                >
                  {cultures
                    .filter((c) => !idCulturesUsed.includes(c.idCulture))
                    .map((c, i) => (
                      <MenuItem key={i} value={c}>
                        {c.libelle}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            }
          </div>
        )}
        <div>
          {arboVitiEndToDisplay.map((indic) => (
            <div className="d-flex align-items-center mb-1" key={"indic-" + indic.idIndicateur}>
              <Grid item xs={4}>
                <div className={indic.afficherGras ? "mr-3 bold" : "mr-3"}>{indic.libelle}</div>
              </Grid>
              <Grid item>
                <Assolement
                  fixedDecimalScale={true}
                  size="small"
                  getValueAssolement={getValueAssolement}
                  indicateur={indic}
                  changeIndicateur={this.handleChangeIndicateur}
                  valueInputProps={
                    indic.libelleUnite !== null && {
                      endAdornment: <InputAdornment position="end">{indic.libelleUnite}</InputAdornment>,
                    }
                  }
                  computedFields={computedFields}
                  showValueN_1N_2
                />
              </Grid>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default compose(withTranslation(), connect(mapStateToProps))(SurfaceSAU);
